export class BillingCodeDTO {
	constructor(
		public id?: number,
		public code?: string,
		public description?: string,
		public price?: number,
		public imagingCenterId?: number
	) {}
}
